import { Component, Injectable, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'app/global/global.service';
import uuid from 'short-unique-id';
import { productTable, billingFrequencyLabels } from '../../general-editor-tabs/product-table/productTable';
import { IProductDto, ProductImageDto } from '../../settings/productlibrary/productlibrary.dto';
import { IPageableResponse } from 'app/global/pagging.dto';
import { ProductlibraryService } from '../../settings/productlibrary/productlibrary.service';
import { SingingPageService } from 'app/main/signing-pages/signing-page/signing-page-service';
import { EditTemplateFacade } from 'app/main/pages/edit-template/store/edit-template-store.facade';
import { EditorEmitterService } from '../../events/editor-emitter.service';
import { take } from 'rxjs';
@Injectable({
  providedIn: 'root',
})

@Component({
  selector: 'app-product-table-modals',
  templateUrl: './product-table-modals.component.html',
  styleUrls: ['./product-table-modals.component.scss']
})
export class ProductTableModalsComponent implements OnInit {
  @ViewChild('modalProductTableSetting') public modalProductTableSetting;
  @ViewChild('addColumnProductTableSettings') public addColumnProductTableSettings;
  @ViewChild('addFromProducts') public addFromProducts;
  @Input() blockUuid: string;

  public uuid = new uuid({ length: 6, dictionary: 'number' });
  public tableUuid: number = 0;
  public productsData: IProductDto[] = [];
  public pagination: IPageableResponse<IProductDto>;
  public page: number = 1;
  public isRecordFetched = false;
  public selectedProducts: IProductDto[] = [];
  public totalPrice: string = '0.00';
  public checkedProducts: number[] = [];
  public productDetails: IProductDto;
  public productLibraryItemListingAppend: boolean = false;
  public billingFrequencyLabels = billingFrequencyLabels();
  public documentCurrency;
  public section: string;
  public sectionId: number;
  public deletedImages: ProductImageDto[] = [];

  /**
   * Contructor
   * @param modalService 
   * @param productTable 
   * @param globalService 
   */
  constructor(
    private modalService: NgbModal,
    private productTable: productTable,
    private globalService: GlobalService,
    private productLibraryService: ProductlibraryService,
    public activeModal: NgbActiveModal,
    private singingPageService: SingingPageService,
    private editTemplateFacade: EditTemplateFacade,
    private editorEmitterService: EditorEmitterService
  ) { }

  // eslint-disable-next-line @angular-eslint/contextual-lifecycle
  ngOnInit(): void {
    this.fetchRouteData()
    this.getDocumentCurrency();
    this.fetchProducts();
    this.showSelectedProducts()
  }

  fetchRouteData() {
    this.editTemplateFacade.templateRoute$.pipe(take(1)).subscribe((templateRoute) => {
      this.section = this.globalService.getTheSectionByRoute(templateRoute.route).toLowerCase();
      this.sectionId = Number(templateRoute.id);
    })
  }

  getDocumentCurrency() {
    const system = this.globalService.getSystemCurrency();
    let docCurrency = system;
    if (!this.productTable.isSigningArea || this.productTable.isEform) {
      const editorCurrency = this.editorEmitterService.getDocumentCurrency();
      if (editorCurrency && String(editorCurrency).trim()) {
        docCurrency = editorCurrency;
      }
    } else {
      if (this.productTable.roleData?.template_settings?.currency) {
        docCurrency = this.productTable.roleData.template_settings.currency;
      }
    }
    this.documentCurrency = docCurrency;
  }

  showSelectedProducts() {
    const blockData = { ...this.globalService.fields_data['blocks'][this.blockUuid] };
    if (!blockData?.currency || !this.documentCurrency || this.documentCurrency === blockData?.currency) {
      const tableItems = Object.values(blockData.table || []);
      this.selectedProducts = tableItems.map(item => ({
        name: item['product_name'],
        description: item['description'],
        price: item['price'],
        qty: item['qty'],
        total: item['total'],
        billing_frequency: item['billing_frequency'],
        sku: item['sku'],
        terms: item['terms'],
        id: item['id'],
        currency: item['currency'],
        images: item['images'],
        custom_fields: item['custom_fields']
      }));
    }
  }

  /**
   * Fetch products from API
   * @param page 
   * @param query 
   */
  fetchProducts(page: number = 1, query: string = '') {
    this.checkedProducts = [];
    this.page = page;
    this.isRecordFetched = false;
    const blockData = { ...this.globalService.fields_data['blocks'][this.blockUuid] };
    if (blockData?.groups && blockData?.groups.length > 0) {
      query += `&groups=${blockData.groups.join(",")}`;
    }
    query += `&currency=${this.documentCurrency}`;
    const fetch$ = this.productTable.isSigningArea
      ? this.singingPageService.fetchProductTableProducts(this.productTable.roleData?.id ?? 0, this.productTable.roleData?.roleable_id ?? 0, this.productTable.isEform, page, query)
      : this.productLibraryService.fetchProducts(page, query);

    fetch$.subscribe({
      next: (response: IPageableResponse<IProductDto>) => {
        this.isRecordFetched = true;
        this.pagination = response;
        this.productsData = response?.data;
      },
      error: (error) => {
        this.globalService.toastrError(error);
        this.pagination = null;
        this.isRecordFetched = true;
      }
    });
  }

  /**
   * Selected checked products
   */
  selectCheckedProducts() {
    for (let i = 0; i < this.checkedProducts.length; i++) {
      const product = this.productsData.find(p => p.id === this.checkedProducts[i]);
      this.selectProduct(product);
    }
    this.checkedProducts = [];
  }

  /**
   * check all products
   * @param $event 
   */
  checkAllProducts($event: Event) {
    const checkbox = $event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    if (isChecked) {
      this.checkedProducts = this.productsData.map(product => product.id);
    } else {
      this.checkedProducts = [];
    }
  }

  /**
   * Check uncheck product
   * @param $event 
   * @param productId 
   */
  checkProduct($event: Event, productId: number) {
    $event.stopPropagation();

    const checkbox = $event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    if (isChecked) {
      if (!this.checkedProducts.includes(productId)) {
        this.checkedProducts.push(productId);
      }
    } else {
      this.checkedProducts = this.checkedProducts.filter(x => x !== productId);
    }
  }

  /**
   * Update total amount
   */
  updateTotalPrice() {
    this.totalPrice = (this.selectedProducts
      .reduce((sum, p) => sum + Number(p.total), 0))
      .toFixed(2);
  }

  /**
   * Update quantity
   * @param type 
   * @param itemIndex 
   */
  updateQty(type: 'plus' | 'minus', itemIndex: number): void {
    const product = this.selectedProducts[itemIndex];
    product.qty += type === 'plus' ? 1 : -1;
    if (product.qty < 1) {
      this.selectedProducts.splice(itemIndex, 1);
    } else {
      product.total = +(product.price * product.qty).toFixed(2);
      this.selectedProducts[itemIndex] = { ...product }; // clone to trigger change detection
    }
    this.updateTotalPrice();
  }

  /**
   * Select Product
   * @param product 
   */
  selectProduct(product: IProductDto) {
    const existingIndex = this.selectedProducts.findIndex(p => p.id === product.id);
    if (existingIndex > -1) {
      const updatedProduct = { ...this.selectedProducts[existingIndex] };
      updatedProduct.qty += 1;
      updatedProduct.total = updatedProduct.qty * updatedProduct.price;
      this.selectedProducts[existingIndex] = updatedProduct;
    } else {
      const newProduct = {
        ...product,
        qty: 1,
        total: product.price
      };
      this.selectedProducts = [...this.selectedProducts, newProduct];
    }
    this.updateTotalPrice();
  }

  pushDeletedImages(products: IProductDto[] = []): void {
    // collect all images (handles undefined images)
    const imagesToDelete = products.reduce((acc: ProductImageDto[], product) => {
      const imgs = product && product.images ? (product.images as ProductImageDto[]) : [];
      return acc.concat(imgs);
    }, []);

    const filtered = imagesToDelete
      .filter(img => !!img && !!img.uuid && !!img.image_url && !img.image_url.includes('productlibrary'));

    if (filtered.length === 0) return;

    // dedupe by uuid and append only new ones
    const existingUuids = new Set(this.deletedImages.map(i => i.uuid));
    const uniqueNew = filtered.filter(i => !existingUuids.has(i.uuid));

    if (uniqueNew.length > 0) {
      this.deletedImages = [...this.deletedImages, ...uniqueNew];
    }
  }

  /**
   * Delete selected product
   * @param itemIndex 
   */
  deletedSelectedItem(itemIndex: number) {
    if (itemIndex === -1) {
      this.pushDeletedImages([...this.selectedProducts])
      this.selectedProducts = [];
    } else {
      this.pushDeletedImages([this.selectedProducts[itemIndex]])
      this.selectedProducts.splice(itemIndex, 1);
    }
    this.updateTotalPrice();
  }

  /**
   * Got to detail fields
   */
  goToDetailFields($event, product: IProductDto) {
    $event.stopPropagation();
    this.productDetails = product;
    this.productLibraryItemListingAppend = true;
  }

  /**
   * Show products listing
   */
  goToProductsListing() {
    this.productLibraryItemListingAppend = false;
  }

  /**
   * Add column to product table setting modal
   */
  openAddColumnProductTableSettings() {
    this.modalService.open(this.addColumnProductTableSettings, {
      windowClass: 'product-table-addColumn-modal',
      backdrop: 'static'
    });
  }

  /**
   * Append selected products to product table
   */
  addProductsToBlock() {
    const blockData = { ...this.globalService.fields_data['blocks'][this.blockUuid] };
    const decimals = parseInt(blockData.no_of_decimals);
    const tableData = [];
    let productsHtml = '';
    for (let i = 0; i < this.selectedProducts.length; i++) {
      const product = this.selectedProducts[i];
      const images = [];
      if (product?.images && product.images.length > 0) {
        for (let j = 0; j < product.images.length; j++) {
          const imgUuid = product.images[j]?.uuid ?? this.uuid();
          images.push({ image_url: product.images[j]?.image_url, uuid: imgUuid });
        }
      }
      const productData = {
        product_name: product.name,
        description: product.description,
        price: Number(product.price).toFixed(decimals),
        qty: product.qty,
        total: Number(product.total).toFixed(decimals),
        billing_frequency: product.billing_frequency,
        billing_frequency_label: product.billing_frequency ? this.billingFrequencyLabels[product.billing_frequency] : this.billingFrequencyLabels['one_time'],
        terms: product.terms,
        terms_value: 0,
        tax_percent: 0,
        tax_amount: 0,
        discount_percent: 0,
        discount_amount: 0,
        id: product.id,
        sku: product.sku,
        currency: product.currency,
        images: images,
        custom_fields: product.custom_fields
      };
      productsHtml += this.productTable.addRow(blockData, productData, this.section, this.sectionId);
      tableData.push(productData);
    }
    const table = document.querySelector('.product-table-content[table-uuid="' + this.blockUuid + '"]');
    const tbody = table?.querySelector('tbody');
    if (tbody) {
      const emptyBtn = document.querySelector(`.product-table-default-box[button-table-uuid="${this.blockUuid}"]`);
      const titleBox = table.querySelector(`.pt-column-title`);
      if (this.selectedProducts.length) {
        emptyBtn?.classList.add('hidden');
        titleBox?.classList.remove('pt-hidden-title');
      } else {
        emptyBtn?.classList.remove('hidden');
        titleBox?.classList.add('pt-hidden-title');
      }
      tbody.innerHTML = productsHtml;
    }

    if (this.deletedImages.length) {
      const toEmit = [...this.deletedImages]; // snapshot
      toEmit.forEach(image => {
        this.editorEmitterService.deleteAttachment.next({
          uuid: image.uuid,
          file_path: image.image_url
        });
      });
      // clear the queue to prevent double-emission
      this.deletedImages = [];
    }

    const updatedBlockData = this.globalService.updateBlock(this.blockUuid, { table: tableData, is_updated: this.productTable.isSigningArea, currency: this.documentCurrency });
    this.productTable.calculateAllSummaryBlockData(this.blockUuid)
    this.productTable.updateProductTableData(updatedBlockData);
    this.activeModal.close();
  }
}
